/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';
import { object } from 'prop-types';
import ReactMarkdown from 'react-markdown';

const styles = () => ({
    root: {
        '& h1': {
            lineHeight: '38px',
            fontSize: '2.5rem',
            fontWeight: 500,
            marginBottom: '0.5rem',
        },
        '& h4': {
            marginTop: '8px',
            marginBottom: '8px',
            fontSize: '1rem',
            lineHeight: '1.5rem',
        },
        '& a': {
            color: '#3333FF',
            textDecoration: 'underline',
            letterSpacing: '0.5px',
        },
    },
});

const PlantsLegalDisclaimers = ({ data, classes }) => {
    const {
        hero: { copy = '' }, title = '', article_header = '', overview = '', article_body = '',
    } = data;
    const browser = useParams();
    const { hash } = useLocation();
    const adjustScrollBar = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 30);
            window.scrollTo(0, -30);
            if (hash && hash === '#accessibility-statement') {
                const element = document.querySelector('#accessibility-statements');
                if (element) {
                    const headerOffset = 150;
                    const elementPosition = element.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                    window.scrollTo({
                        top: offsetPosition,
                    });
                }
            }
        }
    };
    useEffect(() => {
        adjustScrollBar();
    }, []);
    useEffect(() => {
        adjustScrollBar();
    });
    const isPrivacy = browser?.[0] === '/privacy-policy';
    return (
        <Container className={classes?.root}>
            {isPrivacy && (
                <div>
                    <a href="//privacy.truste.com/privacy-seal/validation?rid=5390b55e-b9d5-4405-ae18-eedba5120955" target="_blank" rel="noreferrer">
                        <img style={{ border: 'none' }} src="//privacy-policy.truste.com/privacy-seal/seal?rid=5390b55e-b9d5-4405-ae18-eedba5120955" alt="TRUSTe" align="right" />
                    </a>
                </div>
            )}
            <h1>{title}</h1>
            <ReactMarkdown escapeHtml={false} source={copy} />
            <div id="accessibility-statements">
                <strong>{article_header}</strong>
                <ReactMarkdown escapeHtml={false} source={overview} />
            </div>
            <ReactMarkdown skipHtml={false} source={article_body} />
        </Container>
    );
};

PlantsLegalDisclaimers.propTypes = {
    data: object.isRequired,
    classes: object,
};

PlantsLegalDisclaimers.defaultProps = {
    classes: {},
};

export default withStyles(styles)(PlantsLegalDisclaimers);
